/**
 * @file
 * @author
 */

const baseUrl = new URL(window.location.href);
const base = baseUrl.protocol + '//' + baseUrl.hostname;
// 'http://210.241.91.79';
//const base = '';
const isapi = '/api'
export default {
    // Login
    login: base + '/user/login', // Login
    getProfile: base + '/user/profile', // Get user info
    login2: base + '/user/login2',
    /** Main warehouse management - three APIs use the same address with different parameters **/
    masterMaterial: base + '/warehouse/master/material/', // Get all main warehouse material info /{dept} all /{dept}/{ID} single
    addMasterStock: base + '/warehouse/master/stockin/', // Add main warehouse stock-in order
    addMasterStockout: base + '/warehouse/master/stockout', // Add main warehouse stock-out order
    signedMaterStockin: base + '/warehouse/master/stockin/signing', // Main warehouse stock-in signing
    signedMaterStockout: base + '/warehouse/master/stockout/signing', // Main warehouse stock-out signing
    editMasterMaterial: base + '/warehouse/master/material', // Edit main warehouse material
    /** Sub warehouse page **/
    slaveMaterial: base + '/warehouse/slave/material/', // Get all sub warehouse material info /{dept} all /{dept}/{ID} single
    addSlaveStockin: base + '/warehouse/slave/stockin', // Sub warehouse stock-in order
    signedSlaveStockin: base + '/warehouse/slave/stockin/signing', // Sub warehouse stock-in signing

    /** Signing page **/
    getMasterInByDate: base + '/warehouse/master/stockin/', // Query main warehouse stock-in orders by date range
    getMasterOutByDate: base + '/warehouse/master/stockout/', // Query main warehouse stock-out orders by date range
    getSlaveInByDate: base + '/warehouse/slave/stockin/', // Query sub warehouse stock-in orders by date range
    getSlaveOutByDate: base + '/warehouse/slave/stockout/', // Query sub warehouse stock-out orders by date range

    getAllSet: base + '/warehouse/set/', // Get all signing SOP

    // Dropdown menu data
    getAllCode: base + '/warehouse/m-code', // Get all material codes

    // -------------------- Inspection
    getInfo: base + '/inspection/check/info/', // Get issue list
    addInspection: base + '/inspection/check', // Add inspection order

    // Get inspection list
    getInspectByDate: base + '/inspection/inspect/',
    // Delete inspection order
    deleteInspectionById: base + '/inspection/inspect/',
    // Inspection repair request overview
    getAssignmentByDate: base + '/inspection/assignment/',
    // Dispatch order signing
    signedInspection: base + '/inspection/assignment/signing',
    // Dispatch overview
    getSurvey: base + '/inspection/dispatch/undone/',
    // Dispatch overview signing
    takingSigned: base + '/inspection/dispatch/signing',
    // Inspection feedback form (satisfaction survey signature upload) and content
    surverSigned: base + '/inspection/survey',
    // dispatch order image
    DispatchImage: base + '/inspection/dispatch',
    // History list
    getHistory: base + '/inspection/dispatch/done/',

    // Add repair request order
    editCallRepair: base + '/inspection/maintain', // Add/Edit repair request order
    getAllCategory: base + '/inspection/set-ass-category', // Get all repair categories
    getInsCategory: base + '/inspection/set-ass-category', // Query completed dispatch orders by department and date range
    // Delay completion date signing popup
    // Get signing data
    getDelaySignedData: base + '/inspection/edit-assignment',
    delaySigned: base + '/inspection/edit-assignment/signing',


    // List ---- ---- ----
    getLease: base + '/site/lending/',
    getLeaseHistory: base + '/site/lending/done/',
    // Venue ---- ---- ----
    getBookingData: base + '/site/booking', // Get booking data within specified date range
    getLendingData: base + '/site/booking', // Get lending data within specified date range
    getSiteCalendar: base + '/site/calendar/', // Get current month data
    addAndGetBookingSite: base + '/site/booking', // Add booking data and query data within specified range
    addAndGetLendingSite: base + '/site/lending', // Add venue lending order and query data within specified range
    // Venue signing
    siteVerify: base + '/site/verify',

    // Add venue
    getSite: base + '/site/set-site', // Get venue list
    getActivityType: base + '/site/set-activity', // Get activity types

    // Export
    exportMaster: base + isapi + '/export-w/master/', // Main warehouse export
    exportMaterial: base + isapi + '/export-w/slave/', // Sub warehouse export
    exportSignedOutList: base + isapi + '/export-w/out-list/', // Signing - item distribution statistics export
    exportSignedInList: base + isapi + '/export-w/in-out-list/', // Signing - item receipt/dispatch monthly report export
    exportSignedStockList: base + isapi + '/export-w/stock-list/', // Signing - item inventory list export
    exportInspection: base + isapi + '/export-i/inspection/', // Inspection - inspection list export
    exportQRCode: base + isapi + '/export-i/qr-code/', // Inspection - QR code export
    exportAssignment: base + isapi + '/export-i/assignment/', // Inspection - repair request overview export
    exportDispatch: base + isapi + '/export-i/dispatch/', // Inspection - QR code scan status
    exportHistory: base + isapi + '/export-i/survey/', // Inspection - history list export
    exportMonth: base + isapi + '/export-r/month/', // Venue - monthly report export
    exportArrange: base + isapi + '/export-r/arrange/', // Venue - rotation schedule export
    exportQuick: base + isapi + '/export-r/quick', // Venue - quick report export
    exportAnnual: base + isapi + '/export-r/annual/', // Venue - annual income detail export
    exportSurveyNon: base + isapi + '/export-r/survey-non', // Venue - survey form (no deposit refund) export
    exportSurvey: base + isapi + '/export-r/survey', // Venue - survey form (deposit refund) export

    // nicky
    smsVerify: base + isapi + '/sms/', // SMS verification
    exportReviewLendingOrder: base + isapi + '/export-r/review/', // Export verification result report
    deletelendingAttached: base + isapi + '/download/review_specifyattached/', // Delete attachment data

    DisaptchWorkStart: base + '/inspection/dispatch/work/',

    ChangeDept: base + '/user/change/dept/',
};



// WEBPACK FOOTER //
// ./src/api/index.js